/* eslint-disable ember/no-classic-components */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class DetailFieldSection extends Component {
  title = '';
  description = '';
  items = null;
  buttonLabel = '';
  onRemove = null;
  onAdd = null;
}
